import { Page } from '@/core/architecture'

import { ArtistPostVideosTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistPostVideos Page
 * Implemented as a practical sample.
 */
export const ArtistPostVideos: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistPostVideosTemplate state={state} {...actions} />
}
